import { render, staticRenderFns } from "./imp.vue?vue&type=template&id=237467ba&"
import script from "./imp.vue?vue&type=script&lang=js&"
export * from "./imp.vue?vue&type=script&lang=js&"
import style0 from "./imp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports